/** Determines the unit per which the space quantity is defined by */
var SpaceQuantityUnit;
(function (SpaceQuantityUnit) {
    SpaceQuantityUnit["Building"] = "Building";
    SpaceQuantityUnit["Level"] = "Level";
    SpaceQuantityUnit["Core"] = "Core";
    SpaceQuantityUnit["UnitsStudio"] = "UnitsStudio";
    SpaceQuantityUnit["Units1B1P"] = "Units1B1P";
    SpaceQuantityUnit["Units1B2P"] = "Units1B2P";
    SpaceQuantityUnit["Units2B"] = "Units2B";
    SpaceQuantityUnit["UnitsTotal"] = "UnitsTotal";
})(SpaceQuantityUnit || (SpaceQuantityUnit = {}));

export { SpaceQuantityUnit };
//# sourceMappingURL=space-quantity-unit.js.map
